import { useMemo } from 'react';
import { staticLegacyIds } from '../../common/constants.tsx';

type ConnectDataItem = {
	id: string;
	name: string;
	url?: string;
	iconUrl?: string;
	styleClass?: string;
	section?: boolean;
	items?: ConnectDataItem[] | undefined;
};

export const useFilteredItems = (
	items: ConnectDataItem[] | null,
	shouldFilter = true,
): ConnectDataItem[] =>
	useMemo(() => {
		if (!shouldFilter) return items || [];
		// @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"services" | "collectors" | "attachments" | "eventtypes" | "webhooks-admin" | "greenhopper-lexorank-manage" | "admin-helper-admin-section" | "advanced_section" | "dark_features" | ... 74 more ... | "com.codebarrel.addons.automation__cb-automation" | "com.codebarrel.addons.automation.moderate__cb-automation"'.
		return items?.filter((item: ConnectDataItem) => !staticLegacyIds.includes(item.id)) || [];
	}, [items, shouldFilter]);
